module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/thermo-fisher-db20f44da2d6e4a02557e8bf25f8c620.png";